import { useApi } from '@omnipresentgroup/api';
import type { DocumentsAPI } from '@omnipresentgroup/types';
import { useQuery } from '@tanstack/react-query';

import { API_BASE, API_PATH } from '../constants';
import { transformDocumentsFromAPI } from '../mappers';

const DOCUMENTS_PATH = `${API_BASE}/${API_PATH}`;

export const getDocumentsKey = (id: string) => [API_PATH, id];

type DocumentScope =
  | { companyId: string; userId?: never }
  | { userId: string; companyId?: never };

export const useDocuments = ({
  companyId,
  userId,
  enabled,
}: {
  enabled?: boolean;
} & DocumentScope) => {
  const { GET } = useApi();

  const query = useQuery({
    queryKey: getDocumentsKey(companyId || userId || ''),
    queryFn:
      companyId || userId
        ? () =>
            GET<DocumentsAPI>(
              `${DOCUMENTS_PATH}?${
                companyId ? `companyId=${companyId}` : `userId=${userId}`
              }&documentType=document`,
            )
        : () => Promise.reject(new Error('Invalid id to fetch documents')),
    enabled: enabled,
    select: (data) => transformDocumentsFromAPI(data),
  });

  return query;
};
